export default __webpack_public_path__ + "static/media/img_hr-3.b4a26feb.png";